/**
 * Copyright (c) 2018
 * @summary Label Template
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React from 'react';

class LabelTemplate extends React.Component {
  safeGetOrEmptyString(container, propertyName) {
    return container && container[propertyName] ? container[propertyName] : '';
  }

  render({ props } = this) {
    const { templateData, customClassObject, onChangeLabelTextHandler } = props;
    const value = templateData.inputValue || templateData.value || '';
    const containerClassName = this.safeGetOrEmptyString(customClassObject, 'containerClass');

    if (onChangeLabelTextHandler) {
      const elementClassName = this.safeGetOrEmptyString(customClassObject, 'elementClass');

      return (
        <div className={containerClassName}>
          <textarea
            placeholder="Please enter value here"
            className={elementClassName}
            onChange={onChangeLabelTextHandler}
            value={value}
            maxLength="2000"
          />
        </div>
      );
    }
    return <div className={containerClassName}>{value}</div>;
  }
}
export default LabelTemplate;
